import React, { createContext, useContext, useState } from "react";
import toast from "react-hot-toast";

const CompareContext = createContext(null);
const MAX = 3;

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState([]);

  function addToCompare(product) {
    if (compareList.find(p => p.id === product.id)) { toast("Already in comparison"); return; }
    if (compareList.length >= MAX) { toast.error(`Max ${MAX} products`); return; }
    setCompareList(l => [...l, product]);
    toast.success("Added to compare");
  }

  function removeFromCompare(id) { setCompareList(l => l.filter(p => p.id !== id)); }
  function clearCompare() { setCompareList([]); }
  const isComparing = id => compareList.some(p => p.id === id);

  return (
    <CompareContext.Provider value={{ compareList, addToCompare, removeFromCompare, clearCompare, isComparing }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error("useCompare must be inside CompareProvider");
  return ctx;
}
